import { nanoid } from 'nanoid';

import {
  LOCAL_STORAGE_RESULTS_KEY,
  LOCAL_STORAGE_SESSION_KEY,
  MAX_NO_OF_RESULTS,
  MINUTES_FOR_MAX_NO_OF_RESULTS,
} from '../../constants';

type LocalStorageValue = {
  noOfResults: number;
  firstResultDate: number;
};

type LocalStorageDetails = {
  minutesFromFirstResult: number;
  parsedValue: LocalStorageValue;
};

const resetLocalStorage = () => {
  const entry = {
    noOfResults: 0,
    firstResultDate: Date.now(),
  };
  localStorage.setItem(LOCAL_STORAGE_RESULTS_KEY, JSON.stringify(entry));
};

const handleSessionId = () => {
  const value = localStorage?.getItem(LOCAL_STORAGE_SESSION_KEY);
  if (value == null) {
    const id = nanoid().concat(Date.now().toString());
    localStorage.setItem(LOCAL_STORAGE_SESSION_KEY, id);
  }
};

export const getUserSessionId = () => {
  handleSessionId();
  const value = localStorage?.getItem(LOCAL_STORAGE_SESSION_KEY);

  return value;
};

const getDetails = (value: string): LocalStorageDetails => {
  const parsedValue = JSON.parse(value);
  const currentDate = Date.now();
  const minutesFromFirstResult = (currentDate - parsedValue.firstResultDate) / 60000;
  return {
    parsedValue,
    minutesFromFirstResult,
  };
};

export const initializeLocalStorage = () => {
  handleSessionId();
  const value = localStorage?.getItem(LOCAL_STORAGE_RESULTS_KEY);

  if (value == null) {
    resetLocalStorage();
  } else {
    const { minutesFromFirstResult } = getDetails(value);
    if (minutesFromFirstResult > MINUTES_FOR_MAX_NO_OF_RESULTS) resetLocalStorage();
  }
};

export const increaseNumberOfResults = () => {
  const value = localStorage.getItem(LOCAL_STORAGE_RESULTS_KEY);
  const { parsedValue, minutesFromFirstResult } = getDetails(value);

  if (minutesFromFirstResult > MINUTES_FOR_MAX_NO_OF_RESULTS) resetLocalStorage();
  else {
    const entry = {
      noOfResults: parsedValue.noOfResults + 1,
      firstResultDate: parsedValue.firstResultDate,
    };
    localStorage.setItem(LOCAL_STORAGE_RESULTS_KEY, JSON.stringify(entry));
  }
};

export const allowMoreResults = () => {
  const value = localStorage.getItem(LOCAL_STORAGE_RESULTS_KEY);
  const { parsedValue, minutesFromFirstResult } = getDetails(value);
  if (minutesFromFirstResult > MINUTES_FOR_MAX_NO_OF_RESULTS) {
    resetLocalStorage();
    return true;
  }
  return parsedValue.noOfResults < MAX_NO_OF_RESULTS;
};
